import { Component, NgModule, OnInit, Renderer2, ViewChild } from '@angular/core';
import { FormsModule, NgForm } from '@angular/forms';
import { DatePipe } from '@angular/common';
import { Location } from '@angular/common';
import moment from 'moment';
import Swal from 'sweetalert2';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { LoaderComponent } from 'src/app/shared/components/loader/loader.component';
import { DashboardService } from 'src/app/shared/services/dashboardservices/dashboard.service';




@Component({
  selector: 'app-attendance-request',
  templateUrl: './attendance-request.component.html',
  styleUrl: './attendance-request.component.css',
   standalone: true,
  imports: [CommonModule, FormsModule, RouterModule, LoaderComponent],
  providers: [DatePipe],
})
export class AttendanceRequestComponent implements OnInit {
  public showSpinner = false;
  public selectedMode = 'light';
  public isFilterExpanded = false;
  public startDateFilter = '';
  public endDateFilter = '';
  public useLastMonth = '';
  public requestType = '';
  public requestStatus = '';
  public arr: any[] = [];
  public rejectedReason = '';
  public example: any;

  constructor(private datePipe: DatePipe,
    public dashboardService: DashboardService,

  ) {}

  ngOnInit() {
    // Initialize component
    this.getAttendanceRequests();
  }

  isavailablefeature(feature: string): boolean {
    // Implement feature check logic
    return true;
  }

  toggleFilterSection() {
    this.isFilterExpanded = !this.isFilterExpanded;
  }

  getAttendanceRequests() {
    this.showSpinner = true;

    debugger
    const filters: any = {
    start_date: '',
    end_date: '',
    month_filter:''
  };


    if (this.startDateFilter) {
      filters.start_date = this.startDateFilter;
      filters.end_date = this.endDateFilter || ''; // Always send end_date as empty string when start_date is provided
    }
    if (this.useLastMonth) {
       filters.start_date = '';
      filters.end_date = ''; 
      filters.month_filter = 'last_month';
    }

    this.dashboardService.getMyAttendanceCorrections(filters).then((response: any) => {
      if (response && response.success && response.data) {
        this.arr = response?.data
      } else {
        this.arr = [];
      }
      this.showSpinner = false;
    }).catch((error) => {
      console.error('Error fetching attendance requests:', error);
      this.arr = [];
      this.showSpinner = false;
      Swal.fire('Error', 'Failed to load attendance requests', 'error');
    });
  }

  










  resetfilter() {
    this.startDateFilter = '';
    this.endDateFilter = '';
    this.useLastMonth = '';
    this.requestStatus = '';
    this.getAttendanceRequests();
  }

  getOrdinalSuffix(num: number): string {
    const j = num % 10;
    const k = num % 100;
    if (j === 1 && k !== 11) return 'st';
    if (j === 2 && k !== 12) return 'nd';
    if (j === 3 && k !== 13) return 'rd';
    return 'th';
  }

  isAttendanceApprovedPermission(): boolean {
    return true;
  }

  isAttendanceRejectPermission(): boolean {
    return true;
  }

  onClickRejectRequest(index: number) {
    this.example = index;
  }

  storeValue(index: number) {
    this.example = index;
  }

  approve(index: number) {
    // Implement approve logic
    Swal.fire('Success', 'Attendance request approved', 'success');
  }

  reject(form: NgForm) {
    if (form.valid) {
      // Implement reject logic
      Swal.fire('Success', 'Attendance request rejected', 'success');
    }
  }
}
